module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Logotipo-horizontal-Blanco.98c297b6.png";